<div *ngIf="(season$ | async) as season">

  <div>
    <h1>Season standings</h1>

    <mc-ranking-selector
      [rankings]="rankings$ | async"
      [relativeRouterPath]="relativeRouterPath"
    ></mc-ranking-selector>
  </div>

  <router-outlet></router-outlet>
</div>

